
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/post",
      function () {
        return require("private-next-pages/jobs/post.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/post"])
      });
    }
  